const metronomeWidget = document.getElementById('metronome-widget')
const createScripts = () => {
  const script = document.createElement('script')
  script.setAttribute('src', 'https://mooz.pro/metronome/Metronome.umd.js')
  metronomeWidget.append(script)
}
const createLink = () => {
  const headID = document.getElementsByTagName('head')[0]
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  headID.appendChild(link)
  link.href = 'https://mooz.pro/metronome/Metronome.css'
}

createScripts()
createLink()